import { ReactNode } from 'react';

import { Label } from '@/components/FormElements';

export interface FormGroupProps {
  label: ReactNode;
  hideLabel?: boolean;
  id: string;
  children: ReactNode;
  invalid?: boolean;
  required?: boolean;
  helpText?: ReactNode;
}

export function FormGroup({
  label,
  hideLabel,
  id,
  invalid,
  required,
  children,
  helpText,
}: FormGroupProps) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-col gap-0">
        <Label
          htmlFor={id}
          invalid={invalid}
          required={required}
          hide={hideLabel}
        >
          {label}
        </Label>
        {helpText && <p className="text-body-350 text-secondary">{helpText}</p>}
      </div>
      {children}
    </div>
  );
}
